import React from 'react'
// import ThermoplasticMain from './ThermoplasticMain/ThermoplasticMain'
import MachiningCenters from './MachiningCenters/MachiningCenters'
import Thermopress from './Thermopress/Thermopress'
import PrintingSystems from './PrintingSystems/PrintingSystems'
import CuttingStations from './CuttingStations/CuttingStations'
import WaterjetSystems from './WaterjetSystems/WaterjetSystems'
// import NewsPreview from '../../Modules/NewsBlock/NewsPreview'
import HeaderEngineering from '../../Modules/HeaderEngineering/HeaderEngineering'

const Index = () => {
  return (
    <div>
      <HeaderEngineering />
      {/*<ThermoplasticMain />*/}
      <MachiningCenters />
      <Thermopress />
      <PrintingSystems />
      <CuttingStations />
      <WaterjetSystems />
      {/*<NewsPreview />*/}
    </div>
  )
}

export default Index
